/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { PartyType } from './party-type.model';


export class FutureEvolution {
    dossierCode?: string; // ecf001
    dossierId?: number; // ecf001
    evolutionDescriptionCode?: string; // ecf001
    toDeposeDate?: string; // ecf001
    toHandleDate?: string; // ecf001
    treatmentDate?: string; // ecf001
    courtOfJustice?: string; // ecf001
    partyName?: string; // ecf001
    partyType?: PartyType; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): FutureEvolution {
        if (!data) { return instance; }
        if (data.dossierCode != null) {instance.dossierCode = data.dossierCode; }
        if (data.dossierId != null) {instance.dossierId = data.dossierId; }
        if (data.evolutionDescriptionCode != null) {instance.evolutionDescriptionCode = data.evolutionDescriptionCode; }
        if (data.toDeposeDate != null) {instance.toDeposeDate = data.toDeposeDate; }
        if (data.toHandleDate != null) {instance.toHandleDate = data.toHandleDate; }
        if (data.treatmentDate != null) {instance.treatmentDate = data.treatmentDate; }
        if (data.courtOfJustice != null) {instance.courtOfJustice = data.courtOfJustice; }
        if (data.partyName != null) {instance.partyName = data.partyName; }
        if (data.partyType != null) {instance.partyType = data.partyType; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return FutureEvolution.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: FutureEvolution) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return FutureEvolution.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: FutureEvolution): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
